/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EnrollmentActivity {
  SUBMITTED = 'SUBMITTED',
  WAIVED = 'WAIVED',
  WAIVER_UPDATE = 'WAIVER_UPDATE',
  RESET = 'RESET',
  APPLICATION_SENT = 'APPLICATION_SENT',
  ENROLLMENT_CONFIRMED = 'ENROLLMENT_CONFIRMED',
  ENROLLMENT_DETAILS_UPDATE = 'ENROLLMENT_DETAILS_UPDATE',
  PREMIUM_ADJUSTMENT = 'PREMIUM_ADJUSTMENT',
  ELECTION_DETAILS_UPDATE = 'ELECTION_DETAILS_UPDATE',
  APPLICATION_REVERTED = 'APPLICATION_REVERTED',
  ENROLLMENT_CONFIRMATION_REVERTED = 'ENROLLMENT_CONFIRMATION_REVERTED',
  EFFECTIVE_FROM_UPDATE = 'EFFECTIVE_FROM_UPDATE',
  EFFECTIVE_UNTIL_UPDATE = 'EFFECTIVE_UNTIL_UPDATE',
  EMPLOYEE_MONTHLY_CONTRIBUTION_UPDATE = 'EMPLOYEE_MONTHLY_CONTRIBUTION_UPDATE',
  EMPLOYER_MONTHLY_CONTRIBUTION_UPDATE = 'EMPLOYER_MONTHLY_CONTRIBUTION_UPDATE',
  SELF_PAY_AMOUNT_UPDATE = 'SELF_PAY_AMOUNT_UPDATE',
  PREMIUM_UPDATE = 'PREMIUM_UPDATE',
  ENROLLMENT_CREATED = 'ENROLLMENT_CREATED',
  ENROLLMENT_TEAM_ASSIGNED = 'ENROLLMENT_TEAM_ASSIGNED',
  ENROLLMENT_AGENT_ASSIGNED = 'ENROLLMENT_AGENT_ASSIGNED',
  ENROLLMENT_TAGS_APPLIED = 'ENROLLMENT_TAGS_APPLIED',
  ENROLLMENT_TAGS_REMOVED = 'ENROLLMENT_TAGS_REMOVED',
  COVERED_MEMBERS_UPDATE = 'COVERED_MEMBERS_UPDATE',
  BENEFIT_REMOVED = 'BENEFIT_REMOVED',
  INITIAL_PREMIUM_PAYMENT_COMPLETED = 'INITIAL_PREMIUM_PAYMENT_COMPLETED',
  ENROLLMENT_CALL_LOGGED = 'ENROLLMENT_CALL_LOGGED',
  INITIAL_PREMIUM_PAYMENT_STATUS_UPDATE = 'INITIAL_PREMIUM_PAYMENT_STATUS_UPDATE',
  AUTO_PAY_STATUS_UPDATE = 'AUTO_PAY_STATUS_UPDATE',
  MONTHLY_AUTO_PAY_DATE_UPDATE = 'MONTHLY_AUTO_PAY_DATE_UPDATE',
  ALLOWANCE_UPDATE = 'ALLOWANCE_UPDATE',
  CARRIER_APPLICATION_DETAILS_UPDATE = 'CARRIER_APPLICATION_DETAILS_UPDATE',
}
